module.exports = __webpack_public_path__ + "static/img/c2.0ac6aa84.png";